import {
  Briefcase,
  BotMessageSquare,
  Contact2,
  FolderKanban,
  HeartHandshake,
  Home,
  LayoutList,
  MessageCircleCode,
  LayoutDashboard,
  TrendingUp,
  Settings,
  Users,
} from 'lucide-react';
import { useSelector } from 'react-redux';
import { hasImpactAnalyticsEnabledSelector } from 'redux/selectors';
import { getJobsLink } from '../helpers/urlHelpers';

export const useMainMenu = (activeNetwork) => {
  const menuItems = [];
  const sourcingAgentItems = [];
  const { isManager, isOrganizationManager, features, isCompany, connect } = activeNetwork;
  const isImpactAnalyticsEnabled = useSelector(hasImpactAnalyticsEnabledSelector);
  const isJobBoardEnabled = features && features.includes('job_board');

  if (connect?.hasAccess) {
    menuItems.push({
      icon: Home,
      label: 'Home',
      path: `/networks/${activeNetwork.slug}/home`,
    });
  }

  if (isManager && connect?.hasAccess) {
    menuItems.push({ icon: Contact2, label: 'Contacts', path: `/networks/${activeNetwork.slug}/contacts` });
  }

  if (isCompany) {
    const company = activeNetwork.organization;
    menuItems.push({
      icon: LayoutDashboard,
      path: `/networks/${activeNetwork.slug}/company-profile/${company.id}-${company.slug}`,
      label: `Company profile`,
    });
  }

  if (isManager && (connect?.hasAccess || features?.includes('job_board'))) {
    menuItems.push({
      icon: TrendingUp,
      label: 'Analytics',
      path: `/networks/${activeNetwork.slug}/analytics`,
    });
  }

  const dashboardItem = {
    icon: Home,
    label: 'Dashboard',
    path: `/networks/${activeNetwork.slug}/dashboard`,
    items: [],
    groupName: 'Job board',
  };

  if (isImpactAnalyticsEnabled && isJobBoardEnabled) {
    menuItems.push(dashboardItem);
    dashboardItem.items.push({
      icon: Home,
      label: 'Dashboard',
      path: `/networks/${activeNetwork.slug}/dashboard`,
    });
  }

  if (isManager) {
    dashboardItem.items.push({
      icon: Briefcase,
      label: 'Companies',
      path: `/networks/${activeNetwork.slug}/companies`,
    });
  }

  if (isManager || isOrganizationManager) {
    dashboardItem.items.push({
      icon: LayoutList,
      label: 'Jobs',
      path: getJobsLink({ networkSlug: activeNetwork.slug }),
    });
  }

  if (isManager) {
    dashboardItem.items.push({
      icon: HeartHandshake,
      label: 'Hires',
      path: `/networks/${activeNetwork.slug}/hires`,
    });
  }

  if (isImpactAnalyticsEnabled && isJobBoardEnabled) {
    dashboardItem.items.push({
      icon: Settings,
      label: 'Settings',
      path: `/networks/${activeNetwork.slug}/settings/job-board`,
    });
  }

  if (!connect?.hasAccess) {
    menuItems.push({
      icon: MessageCircleCode,
      label: 'GetroConnect',
      path: `/networks/${activeNetwork.slug}/home`,
    });
  }

  menuItems.push({
    icon: FolderKanban,
    label: 'Projects',
    path: `/networks/${activeNetwork.slug}/projects`,
  });

  menuItems.push({
    icon: Users,
    label: 'CRM',
    path: `/networks/${activeNetwork.slug}/crm`,
  });

  sourcingAgentItems.push({
    icon: BotMessageSquare,
    label: 'Get early access',
    href: 'https://www.getro.com/agents',
    path: '',
    type: 'external',
  });

  return { menuItems, jobItems: dashboardItem.items, sourcingAgentItems };
};
